(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ghost-vehicle-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vehicle-selector')) {
    class VehicleSelector extends HTMLElement {
      connectedCallback() {
        this.make = this.querySelector('[data-vehicle-make]');
        this.model = this.querySelector('[data-vehicle-model]');
        this.generation = this.querySelector('[data-vehicle-generation]');
        this.submit = this.querySelector('[data-vehicle-submit]');
        this.category = this.querySelector('[data-vehicle-category]');
        this.modelOptions = Array.from(this.model.querySelectorAll('option[data-make]'));
        this.generationOptions = Array.from(this.generation.querySelectorAll('option[data-model]'));
        this.categoryOptions = Array.from(this.category.querySelectorAll('option[value]'));
        this.make.addEventListener('change', () => this.updateModels());
        this.model.addEventListener('change', () => this.updateGenerations());
        this.generation.addEventListener('change', () => this.updateSubmit());
        this.category.addEventListener('change', () => this.updateSubmit());
      }

      resetSelect(select, placeholder) {
        select.replaceChildren(new Option(placeholder, ''));
      }

      updateModels() {
        this.resetSelect(this.model, 'Select model');
        this.resetSelect(this.generation, 'Select generation');
        this.generation.disabled = true;
        this.category.value = '';
        this.category.disabled = true;
        this.disableSubmit();

        if (!this.make.value) {
          this.model.disabled = true;
          return;
        }

        this.modelOptions
          .filter((option) => option.dataset.make === this.make.value)
          .forEach((option) => this.model.appendChild(option.cloneNode(true)));

        this.model.disabled = false;
      }

      updateGenerations() {
        this.resetSelect(this.generation, 'Select generation');
        this.category.value = '';
        this.category.disabled = true;
        this.disableSubmit();

        if (!this.model.value) {
          this.generation.disabled = true;
          return;
        }

        const matches = this.generationOptions.filter((option) => option.dataset.model === this.model.value && Number(option.dataset.activeCount || 0) > 0);

        if (matches.length) {
          matches.forEach((option) => this.generation.appendChild(option.cloneNode(true)));
        } else {
          const current = new Option('No products available yet', '');
          current.disabled = true;
          this.generation.appendChild(current);
        }

        this.generation.disabled = false;
      }

      updateSubmit() {
        if (!this.generation.value) {
          this.disableSubmit();
          return;
        }

        let category = this.category.value;
        const path = this.generation.value;
        const selected = this.generation.selectedOptions[0];
        const allowed = (selected?.dataset.categories || '').split('|').filter(Boolean);
        this.category.replaceChildren(new Option('All upgrades', ''));
        this.categoryOptions.filter(o => o.value && allowed.includes(o.value)).forEach(o => this.category.appendChild(o.cloneNode(true)));
        if (category && allowed.includes(category)) this.category.value = category;
        else category = '';
        const dedicatedCollections = {
          '/collections/next-gen-ford-ranger-raptor-2022': {
            'Ghost Performance Package': '/collections/next-gen-ranger-raptor-performance-packages',
            'Tunes': '/collections/next-gen-raptor-ecu-transmission-tuning'
          }
        };
        const intakeCollections = {
          '/collections/ford-everest-next-gen-2022': '/collections/ford-everest-next-gen-snorkels-airboxes-intakes',
          '/collections/ford-ranger-raptor-2-0-bi-turbo-2018-2022': '/collections/ford-ranger-raptor-2-0-snorkels-airboxes-intakes',
          '/collections/ford-ranger-px1-px2-px3': '/collections/ford-ranger-px-series-snorkels-airboxes-intakes',
          '/collections/next-gen-ford-ranger-raptor-2022': '/collections/next-gen-ranger-raptor-snorkels-airboxes-intakes',
          '/collections/next-gen-ford-ranger': '/collections/next-gen-ford-ranger-snorkels-airboxes-intakes',
          '/collections/toyota-landcruiser-70-series': '/collections/toyota-landcruiser-70-series-snorkels-airboxes-intakes',
          '/collections/toyota-landcruiser-76-wagon': '/collections/toyota-landcruiser-76-series-snorkels-airboxes-intakes',
          '/collections/toyota-landcruiser-78-troop-carrier': '/collections/toyota-landcruiser-78-series-snorkels-airboxes-intakes',
          '/collections/toyota-landcruiser-79-series': '/collections/toyota-landcruiser-79-series-snorkels-airboxes-intakes',
          '/collections/toyota-hilux-n70': '/collections/toyota-hilux-n70-snorkels-airboxes-intakes',
          '/collections/toyota-hilux-n80': '/collections/toyota-hilux-n80-snorkels-airboxes-intakes',
          '/collections/toyota-landcruiser-200-series': '/collections/toyota-landcruiser-200-series-snorkels-airboxes-intakes',
          '/collections/toyota-landcruiser-300-series': '/collections/toyota-landcruiser-300-series-snorkels-airboxes-intakes',
          '/collections/toyota-prado-150-series-2009-2024': '/collections/toyota-prado-150-series-snorkels-airboxes-intakes',
          '/collections/toyota-prado-250-series-2024': '/collections/toyota-prado-250-series-snorkels-airboxes-intakes'
        };
        const dedicated = category === 'Intakes' ? intakeCollections[path] : dedicatedCollections[path]?.[category];
        const categoryTypes = { 'Exhausts': 'Exhaust Systems', 'Snorkel & Airbox Kits': 'Snorkel & Airbox Kits' };
        const type = categoryTypes[category] || category;
        const searchTerms = [this.make.selectedOptions[0]?.textContent, this.model.selectedOptions[0]?.textContent, this.generation.selectedOptions[0]?.textContent, category === 'Intakes' ? 'intake' : category === 'Exhausts' ? 'exhaust' : category === 'Tunes' ? 'tune' : category === 'Ghost Performance Package' ? 'performance package' : category].filter(Boolean).join(' ');
        this.submit.href = dedicated || (category ? path + '?filter.p.product_type=' + encodeURIComponent(type) : path);
        this.category.disabled = false;
        this.submit.setAttribute('aria-disabled', 'false');
        this.submit.removeAttribute('tabindex');
      }

      disableSubmit() {
        this.category.disabled = !this.generation.value;
        this.submit.removeAttribute('href');
        this.submit.setAttribute('aria-disabled', 'true');
        this.submit.setAttribute('tabindex', '-1');
      }
    }

    customElements.define('vehicle-selector', VehicleSelector);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
